
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/DebouncedModel.js");

// TODO: Be more smart with added and removed events

/**
 * Keeps track of the user list, and the users' data
 * @type {Model}
 */
module.exports = Model({
	name: "managedmanagerrequests",
	init: init,
	listeners: listeners,
	triggers: triggers,
	debounce: 100, // Debounce pushes by 100 milliseconds

	_who: null,
	_group: null,
	sayViewing: sayViewing

});

function init() {
	this.push({
		outgoing: [],
		search: [],
		denying: null,
		isEmail: false,
		section: "byName",
	});
}

function listeners() {
	return {
		"managedmanageroutgoingrequests:updated": Model.makeExtender("outgoing"),
		"managedmanagerinvites:updated": Model.makeExtender("invites"),
	};
}

function triggers() {
	return {
		"search": handle_management_trigger_search,
		"search:clear": clear_search,
		"request": handle_trigger_management_request,
		"request:bulk": handle_trigger_management_request_bulk,
		"invite": handle_trigger_management_invite,
		"invite:bulk": handle_trigger_management_invite_bulk,
		"requestandinvite:bulk": handle_trigger_management_request_and_invite_bulk,
		"cancel": handle_trigger_cancel,
		"cancel:email": handle_cancel_email_invite,
		"section": handle_trigger_section,
		"view": view,
		"load": load,
	};
}

function load(data) {
	var who = data.who;
	const group = data.group;

	this._who = who;
	this._group = group;

	// Initialize the list of requests
	this.emit("managedmanageroutgoingrequests:trigger:view", {
		managee: who,
		group
	});

	this.emit("managedmanagerinvites:trigger:view", {
		managee: who,
		group
	});
}

function view(data) {
	var who = data.who;
	const group = data.group;

	if (this._who === who) {
		this.sayViewing();
		return;
	}

	this._who = who;
	this._group = group;

	// Initialize the list of requests
	this.emit("managedmanageroutgoingrequests:trigger:view", {
		managee: who,
		group,
	});

	this.emit("managedmanagerinvites:trigger:view", {
		managee: who,
		group,
	});

	this.sayViewing();

	this.emit("usermetrics:trigger:track", "open managed user's manager requests", {
		who,
	});
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who,
		group: this._group
	});
}

function handle_trigger_cancel(data) {
	this.emit("save:trigger:start");
	var request = data.request;
	var managee = data.managee;
	var manager = data.manager;
	const group = this._group;

	this.api.manage.manage.request.cancel(managee, request, group)
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this))
		.then(dispatch_viewed.bind(this, managee));

	this.emit("usermetrics:trigger:track", "cancel management request for managed user", {
		who: this._who,
		manager
	});
}

function handle_cancel_email_invite(data) {
	this.emit("save:trigger:start");
	var request = data.request;
	var managee = data.managee;

	const group = this._group;

	this.api.manage.manage.invite.cancel(managee, request, group)
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this))
		.then(dispatch_viewed.bind(this, managee));

	this.emit("managedmanagerinvites:trigger:cancel", {
		_id: request,
		group
	});

	this.emit("usermetrics:trigger:track", "cancel email management invite for managed user", {
		who: this._who,
	});
}

function handle_management_trigger_search(data) {
	var query = data.query;
	this.api.people.search(query)
		.then(filterOutSelf.bind(this))
		.then(update_search_results.bind(this, query))
		.catch(console.error.bind(console));
	this.emit("usermetrics:trigger:track", "search for user in managed user's manager requests", {
		who: this._who,
	});
}

function filterOutSelf(results) {
	var ownId = this.config.id;
	return results.filter(function (result) {
		return result._id !== ownId;
	});
}

function update_search_results(query, results) {
	var re = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
	var isEmail = (query.match(re)) !== null;

	this.extend({
		query: query,
		search: results,
		isEmail: isEmail
	});
}

function handle_trigger_management_request(data) {
	var managee = data.managee;
	var manager = data.manager;
	var permissions = data.permissions;

	const group = this._group;

	this.emit("save:trigger:start");
	this.api.manage.manage.request.send(managee, manager, permissions, group)
		.then(dispatch_added.bind(this, managee, manager, permissions))
		.then(clear_search.bind(this))
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this))
		.then(dispatch_viewed.bind(this, managee));
	this.emit("usermetrics:trigger:track", "send management request for managed user", {
		who: this._who,
		manager,
	});
}

function handle_trigger_management_request_bulk(data) {
	var managee = data.managee;
	var managerList = data.managerList;
	var permissions = data.permissions;

	const group = this._group;

	this.emit("save:trigger:start");
	this.api.manage.manage.request.sendBulk(managee, managerList, permissions, group)
		.then(dispatch_added_bulk.bind(this, managee, managerList, permissions))
		.then(clear_search.bind(this))
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this))
		.then(dispatch_viewed.bind(this, managee));
	this.emit("usermetrics:trigger:track", "send bulk management request for managed user", {
		who: this._who,
		managers: managerList,
	});
}

function handle_trigger_management_invite(data) {
	var managee = this._who;
	var email = data.query;
	var language = data.language;
	var permissions = data.permissions;
	const group = this._group;

	this.emit("save:trigger:start");
	this.api.manage.manage.invite.send(managee, email, language, permissions, group)
		.then(dispatch_invited.bind(this, managee, email))
		.then(clear_search.bind(this))
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this))
		.then(dispatch_viewed.bind(this, managee));	
	
	this.emit("usermetrics:trigger:track", "send email management invite for managed user", {
		who: this._who,
		email,
	});
}

function handle_trigger_management_invite_bulk(data) {
	var managee = this._who;
	var emailList = data.emailList;
	var permissions = data.permissions;
	const group = this._group;

	this.emit("save:trigger:start");
	this.api.manage.manage.invite.sendBulk(managee, emailList, permissions, group)
		.then(dispatch_invited_bulk.bind(this, managee, emailList))
		.then(clear_search.bind(this))
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this))
		.then(dispatch_viewed.bind(this, managee));
	this.emit("usermetrics:trigger:track", "send bulk email management invite for managed user", {
		who: this._who,
	});
}

function handle_trigger_management_request_and_invite_bulk(data) {
	var managee = this._who;
	var emailList = data.emailList;
	var managerList = data.managerList;
	var permissions = data.permissions;
	const group = this._group;
	var promiseList = [];

	this.emit("save:trigger:start");
	if (managerList && managerList.length) {
		promiseList.push(this.api.manage.manage.request.sendBulk(managee, managerList, permissions, group));
	}
	if (emailList && emailList.length) {
		promiseList.push(this.api.manage.manage.invite.sendBulk(managee, emailList, permissions, group));
	}

	Promise.all(promiseList)
		.then(dispatch_done.bind(this))
		.then(clear_search.bind(this))
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this))
		.then(dispatch_viewed.bind(this, managee));
	
	this.emit("usermetrics:trigger:track", "send bulk management request and email invite for managed user", {
		who: this._who,
		managers: managerList,
	});
}

function requestFinished() {
	this.emit("save:trigger:finish");
}

function dispatch_added(managee, manager, permissions) {
	var carecoordinator = this._who;
	this.dispatch("added", {
		managee: managee,
		manager: manager,
		carecoordinator: carecoordinator,
		permissions: permissions
	});
}

function dispatch_added_bulk(managee, managerList, permissions) {
	var carecoordinator = this._who;
	managerList.forEach((manager) => {
		this.dispatch("added", {
			managee: managee,
			manager: manager,
			carecoordinator: carecoordinator,
			permissions: permissions
		});
	});

}

function dispatch_done() {
	this.dispatch("done");
}


function dispatch_invited(managee, email, permissions) {
	this.dispatch("invited", {
		managee: managee,
		email: email,
		permissions: permissions
	});
}

function dispatch_invited_bulk(managee, emailList, permissions) {
	emailList.forEach(({ email }) => {
		this.dispatch("invited", {
			managee: managee,
			email: email,
			permissions: permissions
		});
	});
}

function handle_trigger_section(data) {
	var section = data.name;
	this.extend({
		section: section,
		search: [],
		query: ""
	});
}

function clear_search() {
	this.extend({
		search: [],
		section: "byName",
		isEmail: false,
		query: ""
	});
}

function dispatch_viewed(who) {
	this.dispatch("viewed", {
		who,
		section: "manage",
		timestamp: new Date().toISOString()
	});
}